/*
 * @Author: yanghongyu
 * @Date: 2021-09-10 13:26:53
 * @LastEditTime: 2022-01-16 15:29:58
 * @LastEditors: wangyaping
 * @Description:淘宝lib-flexible
 */
// rem等比适配配置文件
// 基准大小
// https://github.com/postcss/postcss-load-config
// eslint-disable-next-line
const baseSize = 12
// 设置 rem 函数
function setScreen() {
  // 当前页面屏幕分辨率相对于 1440宽的缩放比例，可根据自己需要修改
  // eslint-disable-next-line
  const scale = document.documentElement.clientWidth / 1440
  // 设置页面根节点字体大小最高放大比例
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 1) + 'px'
}
// 初始化
setScreen()
// 改变窗口大小时重新设置 rem
window.onresize = function() {
  setScreen()
}
